import { NavLink } from 'react-router-dom';
import {
  ExitToAppSharp as ExitToAppSharpIcon,
  Home as HomeIcon,
} from '@mui/icons-material';
import {
  AppBar,
  Container,
  Grid,
  IconButton,
  Toolbar,
  Tooltip,
} from '@mui/material';
import { sso } from '../../../auth/sso';

import './NavMenu.scss';

export function NavMenu() {
  const handleLogout = () => {
    // Clears the local session, then redirects to the auth site's logout to revoke the
    // shared session.
    sso.logout();
  };
  //const query = useQuery('profile', GetProfilePicture());

  return (
    <header>
      <AppBar id="nav-bar" color="offwhite" position={'sticky'} elevation={0}>
        <Toolbar id="toolbar">
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <Container maxWidth={'sm'}>
                <img
                  id="blc-logo"
                  src="https://www.baltlife.com/img/logo@2x.png"
                  alt="Baltimore Life Co. Logo"
                />
              </Container>
            </Grid>
            <Grid id="space-holder" item xs={6}></Grid>
            <Grid id={'action-buttons'} item xs={3}>
              <NavLink to="/">
                <Tooltip title={'Home'} aria-label={'Home'}>
                  <IconButton aria-label="Home" size={'small'}>
                    <HomeIcon fontSize={'small'} />
                  </IconButton>
                </Tooltip>
              </NavLink>
              <Tooltip title={'Sign Out'} aria-label={'Sign Out'}>
                <IconButton
                  aria-label="SignOut"
                  onClick={() => {
                    handleLogout();
                  }}
                  size={'small'}
                >
                  <ExitToAppSharpIcon fontSize={'small'} />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </header>
  );
}
